import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getError } from '../../../lib/getError';
import {
  DUPLICATE_ACCOUNT_REGISTRATION_ERROR_MESSAGE,
  VSE_MATCH_ERROR_MESSAGE,
} from '../../../lib/constants';

import './index.css';

export const REGISTRATION_VALIDATION_MESSAGE =
  'Please see required fields above to complete registration.';

const BannerFormErrors = ({
  apiFailed,
  errorDetail,
  statusCode,
  formSubmissionError,
  validationMessage,
  showDuplicateTitle,
  apiErrorId,
  validationSummaryId,
}) => {
  const isTitledBannerError = showDuplicateTitle && (
    errorDetail === DUPLICATE_ACCOUNT_REGISTRATION_ERROR_MESSAGE
    || errorDetail === VSE_MATCH_ERROR_MESSAGE
  );
  const showApiError = apiFailed && errorDetail;

  if (!showApiError && !formSubmissionError) {
    return null;
  }

  return (
    <div className="banner-form-errors">
      {showApiError && (
        <div
          id={apiErrorId}
          className={classNames('banner-form-error', { 'submit-error': !isTitledBannerError })}
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          tabIndex={-1}
          dangerouslySetInnerHTML={{__html: getError(errorDetail, statusCode, { showDuplicateTitle })}}
        />
      )}
      {formSubmissionError && (
        <p
          id={validationSummaryId}
          className="banner-form-error submit-error"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          tabIndex={-1}
        >
          {validationMessage}
        </p>
      )}
    </div>
  );
};

BannerFormErrors.propTypes = {
  apiFailed: PropTypes.bool,
  errorDetail: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  statusCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  formSubmissionError: PropTypes.bool,
  validationMessage: PropTypes.string,
  showDuplicateTitle: PropTypes.bool,
  apiErrorId: PropTypes.string,
  validationSummaryId: PropTypes.string,
};

BannerFormErrors.defaultProps = {
  apiFailed: false,
  errorDetail: false,
  statusCode: false,
  formSubmissionError: false,
  validationMessage: REGISTRATION_VALIDATION_MESSAGE,
  showDuplicateTitle: true,
  apiErrorId: 'register-api-error',
  validationSummaryId: 'register-validation-summary',
};

export default BannerFormErrors;
